<template>
    <main id="main" class="main-site">
        <div class="container">
            <div class="wrap-breadcrumb">
                <ul>
                    <li class="item-link">
                        <router-link to="/loja" class="fa fa-home"></router-link>
                    </li>
                    <li class="item-link">
                        <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
                    </li>
                    <li class="item-link">
                        <span>Cadastro de Clientes para venda direta</span>
                    </li>
                </ul>
            </div>
            <p class="alert alert-danger" style="text-align: justify">
                <span><u>IMPORTANTE:</u></span>
                <ul style="list-style: disc !important; ">
                    <li><b>Na venda de Gerador Solar, os dados e endereço do Cliente Final devem ser os da Unidade Consumidora onde o gerador será instalado. Ou seja: utilize os dados da Conta de Luz do Cliente Final, a mesma que farão o upload no campo “Conta de Luz da Unidade Consumidora”.</b></li>
                    <li>O cadastro do Cliente Final para Venda Direta deve ser realizado com os dados e endereço do local de entrega. Certifique-se de que o CPF é válido, confira nomes, datas e telefone/email de contato.</li>
                    <li>Não é permitido utilizar dados da sua revenda para o cadastro de Clientes Finais, incluindo email e telefone.</li>
                    <li>Ao fornecer os dados do Cliente Final, a revenda, na qualidade de Controladora de dados de seus Clientes, declara e garante que Tratou os dados de Clientes cumprindo todos os requisitos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018) e quaisquer outras leis e regulamentações brasileiras vinculantes aplicáveis à proteção dos dados pessoais; A REVENDA é responsável por garantir que os Dados Pessoais de Terceiros submetidos a Tratamento pela ALDO sob o Contrato são legítimos, atualizados e precisos, e que o tratamento foi autorizado pelo respectivo Titular dos Dados Pessoais ou atende a uma das bases legais para Tratamento previstas na LGPD.</li>
                </ul>
            </p>
            <div class="main-content-area">
                <div class="form-item">
                    <form name="frm-cadastro-venda-direta" @submit.prevent="formTipoPessoa">
                        <div class="row">
                            <div class="col-xs-12">
                                <h3 class="box-title">Cadastro de Clientes para venda direta</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-6 col-sm-3">
                                <div class="choose-radio-methods">
                                    <label class="radio-option">
                                        <input name="radio-tipo-pessoa"
                                               value="1"
                                               type="radio"
                                               checked
                                               v-model="formRegister.tipo">
                                        <span>Pessoa Jurídica</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-xs-6 col-sm-3">
                                <div class="choose-radio-methods">
                                    <label class="radio-option">
                                        <input name="radio-tipo-pessoa"
                                               value="0"
                                               type="radio"
                                               checked
                                               v-model="formRegister.tipo">
                                        <span>Pessoa Física</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                    <!-- Pessoa Fisica -->
                    <div class="docs-pessoais" v-if="formRegister.tipo==0">
                        <form @submit.prevent="frmRegisterpf" v-on:keyup.enter="submitForms()" action="#" method="get" name="frm-billing">
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpf.cpf"
                                                :form="frmRegisterpf"
                                                label="CPF conforme Unidade Consumidora"
                                                mask="###.###.###-##"
                                                validationType="cpf"></FormHelper>
                                </div>

                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpf.dataNascimento"
                                                :form="frmRegisterpf"
                                                label="Data Nascimento"
                                                validationType="pastDate"
                                                icon="fa-calendar"
                                                mask="##/##/####"
                                                placeholder="12/12/2000"></FormHelper>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpf.nome"
                                                :form="frmRegisterpf"
                                                label="Nome completo conforme documento oficial"
                                                maxlength="60"
                                                placeholder="Nome"
                                                validationType="quotes"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpf.rg"
                                                :form="frmRegisterpf"
                                                label="RG"
                                                mask="##############"></FormHelper>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpf.orgaoEmissor"
                                                :form="frmRegisterpf"
                                                label="Orgão Emissor"
                                                maxlength="7"
                                                validationType="quotes"></FormHelper>
                                </div>
                            </div>
                        </form>
                    </div>

                    <!-- Pessoa Jurídica -->
                    <div class="docs-pessoais" v-if="formRegister.tipo==1">
                        <form @submit.prevent="frmRegisterpj"
                              v-on:keyup.enter="submitForms()" action="#" method="get" name="frm-billing">
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.cnpj"
                                                :form="frmRegisterpj"
                                                label="CNPJ"
                                                mask="##.###.###/####-##"
                                                validationType="cnpj"
                                                :disabled="frmRegisterpj.loadingCnpj || disabledForm"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <Loader style="margin-top: 20px" v-if="frmRegisterpj.loadingCnpj" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.razaoSocial"
                                                :form="frmRegisterpj"
                                                label="Razão Social"
                                                maxlength="60"
                                                :disabled="disabledForm"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.nomeFantasia"
                                                :form="frmRegisterpj"
                                                label="Nome Fantasia"
                                                maxlength="60"
                                                :disabled="frmRegisterpj.disabledFantasia"
                                                validationType="quotes"></FormHelper>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.inscricaoEstadual"
                                                :form="frmRegisterpj"
                                                label="Inscrição Estadual"
                                                placeholder="Somente números"
                                                type="number"
                                                :disabled="disabledForm"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.cnae"
                                                :form="frmRegisterpj"
                                                label="CNAE"
                                                placeholder="CNAE"
                                                type="text"
                                                :disabled="disabledForm"></FormHelper>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.crt"
                                                :form="frmRegisterpj"
                                                :options="yesOrNoOptions()"
                                                type="radio"
                                                label="Empresa optante pelo lucro real?"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.fundacao"
                                                :form="frmRegisterpj"
                                                validationType="pastDate"
                                                label="Fundação"
                                                icon="fa-calendar"
                                                mask="##/##/####"
                                                placeholder="12/12/2000"
                                                :disabled="disabledForm"></FormHelper>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    
                                    <FormHelper :inputVar="frmRegisterpj.qtdeFilias"
                                                :form="frmRegisterpj"
                                                label="Quantidade de Filiais"
                                                type="number"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.ramoAtividade"
                                                :form="frmRegisterpj"
                                                :options="frmRegisterpj.ramoAtividades"
                                                type="select"
                                                label="Ramo Atividade"
                                                placeholder="Selecione o Ramo Atividade"></FormHelper>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.comprador"
                                                :form="frmRegisterpj"
                                                label="Comprador"
                                                maxlength="30"
                                                validationType="quotes"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.diretor"
                                                :form="frmRegisterpj"
                                                label="Diretor"
                                                maxlength="30"
                                                validationType="quotes"></FormHelper>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmRegisterpj.financeiro"
                                                :form="frmRegisterpj"
                                                label="Financeiro"
                                                maxlength="30"
                                                validationType="quotes"></FormHelper>
                                </div>
                            </div>
                        </form>

                        <div id="partner" v-if="(socios.length - socioIndex) > 0">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="box-title">Sócio/Proprietário</h3>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <h5 class="alert alert-info">
                                        Quantidade de sócios a serem adicionados: {{ socios.length - socioIndex }} sócios.
                                    </h5>
                                </div>
                            </div>

                            <form @submit.prevent="savePartner">
                                <div class="row">
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="frmSocio.cpfSocio" :form="frmSocio" validationType="cpf" mask="###.###.###-##" label="CPF" placeholder="Digite o CPF"></FormHelper>
                                    </div>

                                    <div class="col-md-6">
                                        <FormHelper :inputVar="frmSocio.dataNascimentoSocio" :form="frmSocio" validationType="pastDate" icon="fa-calendar" mask="##/##/####" label="Data de Nascimento" placeholder="Digite a Data de Nascimento"></FormHelper>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="frmSocio.nomeSocio" :form="frmSocio" maxlength="60" validationType="quotes" label="Nome" placeholder="Informe o CPF e a data de nascimento" :disabled="true"></FormHelper>
                                    </div>

                                    <div class="col-md-6">
                                        <FormHelper :inputVar="frmSocio.rgSocio" :form="frmSocio" label="RG" mask="##############" placeholder="Digite o RG"></FormHelper>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="frmSocio.cargoSocio" :form="frmSocio" validationType="quotes" maxlength="50" label="Cargo" placeholder="Digite o Cargo" icon="fa-briefcase"></FormHelper>
                                    </div>

                                    <div class="col-md-6">
                                        <FormHelper :inputVar="frmSocio.emailSocio" :form="frmSocio" maxlength="50" id="email-socio" validationType="email" icon="fa-envelope" label="E-mail" placeholder="Digite o E-mail"></FormHelper>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="frmSocio.telefoneSocio" :form="frmSocio" maxlength="15" id="telefone-socio" validationType="phone" label="Telefone" :mask="['(##) ####-####', '(##) #####-####']" placeholder="Digite o Telefone" icon="fa-phone"></FormHelper>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <button id="btnPartner"
                                                class="btn primary-button pull-left"
                                                type="submit">
                                            Adicionar Sócio
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div v-else-if="hasPartners">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="box-title">Sócio/Proprietário</h3>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <h4 class="alert alert-success">Todos os sócios foram adicionados!</h4>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="!hasPartners">
                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="box-title">Sócio/Proprietário</h3>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <h4 class="alert alert-warning">Esta empresa não contém sócios cadastrados na receita!</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- fim Pessoa Jurídica -->
                    <!-- Endereço -->
                    <div class="frm-endereco" v-if="formRegister.tipo==0 || formRegister.tipo==1">
                        <form v-on:keyup.enter="submitForms()"
                              @submit.prevent="frmEndereco" action="#" method="get" name="frm-billing">
                            <div class="row">
                                <div class="col-xs-12">
                                    <h3 class="box-title">Endereço DA UNIDADE CONSUMIDORA</h3>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.cep"
                                                :form="frmEndereco"
                                                label="CEP DA UNIDADE CONSUMIDORA"
                                                validationType="cep"
                                                mask="#####-###"
                                                placeholder="00000-000"
                                                linkInLabel="<a target='_blank' href='http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm'>Não sei o cep</a>"
                                                :disabled="frmEndereco.disabledCep"
                                                :change="getCepInfos"
                                                ></FormHelper>
                                </div>
                            </div>
                            <p></p>
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.estado"
                                                :form="frmEndereco"
                                                :options="getStates()"
                                                type="select"
                                                label="Estado DA UNIDADE CONSUMIDORA"
                                                placeholder="Selecione um Estado"
                                                :disabled="frmEndereco.disabledEstado"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.cidade"
                                                :form="frmEndereco"
                                                :options="frmEndereco.cidades"
                                                type="select"
                                                label="Cidade DA UNIDADE CONSUMIDORA"
                                                placeholder="Selecione uma Cidade"
                                                :disabled="frmEndereco.cidadeDisabled"></FormHelper>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.endereco"
                                                :form="frmEndereco"
                                                maxlength="38"
                                                label="Endereço DA UNIDADE CONSUMIDORA"
                                                placeholder="Digite o endereço"
                                                :disabled="disabledForm || frmEndereco.disabledEndereco"
                                                validationType="quotes"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.bairro"
                                                :form="frmEndereco"
                                                label="Bairro"
                                                maxlength="60"
                                                :disabled="disabledForm || frmEndereco.disabledBairro"
                                                validationType="quotes"></FormHelper>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.numero"
                                                :form="frmEndereco"
                                                maxlength="6"
                                                label="Número do endereço"
                                                :disabled="disabledForm"
                                                validationType="quotes"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.complemento"
                                                :form="frmEndereco"
                                                maxlength="10"
                                                label="Complemento"
                                                placeholder="Complemento"
                                                :disabled="disabledForm || frmEndereco.disabledComplemento"
                                                validationType="quotes"></FormHelper>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6" style="z-index:999;">
                                    <FormHelper :inputVar="frmEndereco.comprovanteEndereco"
                                                :form="frmEndereco"
                                                label="Comprovante Endereço: CONTA DE LUZ DA UNIDADE CONSUMIDORA"
                                                maxlength="60"
                                                type="file"
                                                :fileTypes="['pdf', 'jpg', 'png']"></FormHelper>
                                </div>
                                <div class="col-md-2" style="z-index:1000;">
                                    <FormHelper :inputVar="frmEndereco.enderecoRural"
                                                :form="frmEndereco"
                                                :options="yesOrNoOptions()"
                                                type="radio"
                                                label="Endereço Rural?"></FormHelper>
                                </div>
                                <div class="col-md-4">
                                    <div class="alert alert-warning" style="display: flex;padding: 5px 5px 5px 20px;text-align: initial;">
                                                <h6 style="font-size: 13px;"><b>Considera-se Endereço Rural :</b> Zona Rural, Rodovias, Distritos e locais acessíveis apenas por estradas não asfaltadas.</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="box-title">Contatos DO CLIENTE DA UNIDADE CONSUMIDORA (não use dados da sua Revenda)</h3>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.telefone"
                                                :form="frmEndereco"
                                                validationType="phone"
                                                label="Telefone"
                                                mask="(##) ####-####"
                                                placeholder="(00) 0000-0000"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.telefoneCelular"
                                                :form="frmEndereco"
                                                validationType="phone"
                                                label="Telefone Celular"
                                                mask="(##) #####-####"
                                                placeholder="(00) 00000-0000"></FormHelper>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.email"
                                                validationType="email"
                                                :form="frmEndereco"
                                                label="E-Mail"></FormHelper>
                                </div>
                                <div class="col-md-6">
                                    <FormHelper :inputVar="frmEndereco.emailConfirme"
                                                :form="frmEndereco"
                                                label="E-Mail Confirme"
                                                validationType="comparison"
                                                :compareTo="frmEndereco.email"></FormHelper>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- fim Endereço -->

                    <div v-if="(frmRegisterpf.attemptSubmit || frmRegisterpj.attemptSubmit) && formErrors > 0" class="row">
                        <div class="col-md-12">
                            <div class="form-errors alert alert-danger" role="alert">
                                <i class="fa fa-warning"></i>
                                Seu formulário possui {{ formErrors }} erros. Por favor, corrija antes de prosseguir.
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="formRegister.tipo == 0 || formRegister.tipo == 1">
                        <div class="col-md-1">
                            <button aria-label="Salvar" class="btn btn-primary" v-on:click="submitForms()" :disabled="(formErrors > 0 && (frmRegisterpf.attemptSubmit || frmRegisterpj.attemptSubmit)) || loadingRegister">
                                Salvar
                            </button>
                        </div>
                        <div v-if="loadingRegister" class="col-md-5">
                            <Loader />
                        </div>
                    </div>
                    <div class="row" v-if="formRegister.tipo == 0 || formRegister.tipo == 1">
                        <div class="alert alert-warning" style="text-align: justify">
                            <ul type="none">
                                <li>Ao Clicar em "Salvar", os dados do Cliente serão consultados na base da Receita Federal, podendo levar até 5 minutos para retornar.</li>
                                <li>Se validado pela Receita, um pop-up informará: "Cliente cadastrado com sucesso".</li>
                                <li>Se houver falha na validação, por favor cheque os dados e clique em "Salvar" novamente.</li>
                                <li>O cadastro só será recebido pelo sistema Aldo mediante validação pela Receita.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import FormHelper from "./partials/FormHelper.vue";
    import axios from 'axios';

    export default {
        name: "CadastroVendaDireta",
        data() {
            return {
                disabledForm: false,
                requiredFieldMessage: "Por favor, preencha o campo acima",
                atividadesSecundarias: [],
                formRegister: {
                    tipo: null
                },
                frmRegisterpf: {
                    attemptSubmit: false,

                    //* Pesssoa Fisica */
                    cpf: new this.formInput(),
                    nome: new this.formInput(),
                    dataNascimento: new this.formInput(),
                    rg: new this.formInput(false),
                    orgaoEmissor: new this.formInput(false),
                    loadingCpf: false
                },
                frmRegisterpj: {
                    attemptSubmit: false,

                    /* Pesssoa Juridica */
                    cnpj: new this.formInput(),
                    razaoSocial: new this.formInput(),
                    nomeFantasia: new this.formInput(false),
                    inscricaoEstadual: new this.formInput(false),
                    crt: new this.formInput(true),
                    fundacao: new this.formInput(),
                    cnae: new this.formInput(),
                    qtdeFilias: new this.formInput(false),
                    ramoAtividade: new this.formInput(),
                    comprador: new this.formInput(),
                    diretor: new this.formInput(),
                    financeiro: new this.formInput(),
                    cnpjInvalid: false,
                    situacaoIe: false,
                    ramoAtividades: [],
                    disabledFantasia: true,
                    loadingCnpj: false,
                    loadingValidCNPJ: false
                },
                frmSocio: {
                    nomeSocio: new this.$formInput(),
                    cpfSocio: new this.$formInput(),
                    rgSocio: new this.$formInput(),
                    dataNascimentoSocio: new this.$formInput(),
                    cargoSocio: new this.$formInput(),
                    emailSocio: new this.$formInput(),
                    telefoneSocio: new this.$formInput(),
                    attemptSubmit: false
                },
                frmEndereco: {
                    attemptSubmit: false,
                    estado: new this.formInput(),
                    cidade: new this.formInput(true),
                    cep: new this.formInput(),
                    cepIsInvalid: false,
                    endereco: new this.formInput(),
                    numero: new this.formInput(),
                    complemento: new this.formInput(false),
                    bairro: new this.formInput(),
                    telefone: new this.formInput(),
                    telefoneCelular: new this.formInput(),
                    email: new this.formInput(),
                    emailConfirme: new this.formInput(),
                    comprovanteEndereco: new this.formInput(),
                    // transportadora: new this.formInput(),
                    // transportadoras: [],
                    cidades: [],
                    disabledEndereco: false,
                    cidadeDisabled: false,
                    disabledEstado: false,
                    disabledCep: false,
                    disabledComplemento: true,
                    disabledBairro: false,
                    enderecoRural: new this.formInput(true),
                },
                socios: [],
                socioIndex: 0,
                hasPartners: false,
                loadingRegister: false,
                invalidCnpj: false,
                ramoAtividade: '',
                confirmaCadastroClienteRural: false
            };
        },
        components: {
            FormHelper
        },
        computed: {
            formErrors: function () {
                // Retorna os campos que estão com erro de validação
                const errorsEndereco = Object.keys(this.frmEndereco).filter((key) => this.frmEndereco[key].validation && !this.frmEndereco[key].validation.status)

                if (this.formRegister.tipo == 1) {
                    let errors = Object.keys(this.frmRegisterpj).filter((key) => this.frmRegisterpj[key].validation && !this.frmRegisterpj[key].validation.status)
                    return (errors.length + errorsEndereco.length);
                }
                else if (this.formRegister.tipo == 0) {
                    let errors = Object.keys(this.frmRegisterpf).filter((key) => this.frmRegisterpf[key].validation && !this.frmRegisterpf[key].validation.status)
                    return (errors.length + errorsEndereco.length);
                }
            },
            formSocioErrors: function () {
                // Retorna os campos que estão com erro de validação
                const errors = Object.keys(this.frmSocio).filter(
                    (key) => this.frmSocio[key].required && this.frmSocio[key].validation && !this.frmSocio[key].validation.status
                );
                return errors.length;
            }
        },
        watch: {
            "formRegister.tipo": function (val) {
                if (val == 0)
                    this.frmEndereco.disabledComplemento = false;
            },
            "frmEndereco.cepIsInvalid": function (val) {
                if (val == true) {
                    this.frmEndereco.disabledEndereco = false;
                    this.frmEndereco.disabledBairro = false;
                    this.frmEndereco.cepIsInvalid = true;
                }
                else {
                    this.getCepInfos(this.frmEndereco.cep.value);
                }
            },
            "frmEndereco.estado.value": function (val) {
                this.loadCidades();
            },
            "frmEndereco.cep.value": function (val) {
                if (val.length == 9) {
                    if (this.frmEndereco.disabledCep == false)
                        this.getCepInfos(val);
                }
            },
            "frmRegisterpj.cnpj.value": async function (val) {
                if (val.length == 18) {
                    let cnpj = val.replace(/[^\d]+/g, '');
                    let valida = await this.validaCnpj(cnpj);
                    if (valida && this.frmRegisterpj.cnpj.validation.status) {
                        this.frmRegisterpj.loadingCnpj = true;
                        this.getInfosFinancialCnpj(cnpj);
                        this.getInfosCnpj(cnpj);
                    }
                    else
                        this.frmRegisterpj.cnpjInvalid = true;
                }
            },
            "frmRegisterpf.cpf.value": async function (val) {
                if (val.length == 14) {
                    let cpf = val.replace(/[^\d]+/g, '');
                    let valida = await this.validaCpf(cpf);
                    if (valida && this.frmRegisterpj.cnpj.validation.status) {
                        this.frmRegisterpj.loadingCnpj = true;
                        this.getInfosFinancialCnpj(cnpj);
                        this.getInfosCnpj(cnpj);
                    }
                    else
                        this.frmRegisterpf.cpfInvalid = true;
                }
            }
        },
        mounted() {
            const self = this;

            let ramo = {}
            let profissao = {}

            $.ajax({
                url: this.$apiUrl + "Session.svc/getsessions",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                success: data => {
                    if (data.DadosCliente != null && data.DadosCliente.CliEnvioucontrato === 1) {
                        swal({
                            title: "A revenda logada não tem contrato comercial para fazer Venda Direta!",
                            icon: "warning"
                        }).then(() => location.href = `${self.$SiteUrl}/loja/minha-conta`)
                    }
                },
                error: () => {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning"
                    }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href)
                }
            });

            $.ajax({
                url: this.$apiUrl + "RamoAtividade.svc/getramoatividades",
                dataType: 'json',
                contentType: "application/json",
                type: 'GET',
                success: (data) => {
                    data.forEach((element) => {
                        ramo = {};
                        ramo.code = element.RatCodigo,
                            ramo.label = element.RatDescricao;
                        self.frmRegisterpj.ramoAtividades.push(ramo);
                    })
                }
            })
        },
        methods: {
            async validaCnpj(cnpj) {
                return axios.get(`${this.$apiUrl}ClienteVendaDireta.svc/verificacnpj/?cnpj=${cnpj}`)
                    .then((response) => {
                        if (response.data.Item1) {
                            swal({
                                title: response.data.Item2,
                                icon: 'warning'
                            })
                            this.frmRegisterpj.cnpj.value = '';
                            return false;
                        }
                        return true;
                    })
            },
            async handleCepBlur() {
            if (this.cep) {
                await this.getCepInfos(this.cep);
                }
            },
            async validaCpf(cpf) {
                 return axios.get(`${this.$apiUrl}ClienteVendaDireta.svc/verificacnpj/?cnpj=${cpf}`)
                    .then((response) => {
                        if (response.data.Item1) {
                            swal({
                                title: response.data.Item2,
                                icon: 'warning'
                            })
                            this.frmRegisterpj.cnpj.value = '';
                            return false;
                        }
                        return true;
                    })
            },
            mostrarIP(){
                fetch('https://api.ipify.org?format=json')
                .then(x => x.json())
                .then(({ ip }) => {
                    this.term = ip;
                });
            },
            savePartner() {
                this.frmSocio.attemptSubmit = true;
                if (this.socioIndex > 0 && this.socios.length > 0) {
                    let validaSocioRepetido = this.socios.filter(c => (c.CsoCpf && c.CsoCpf == this.frmSocio.cpfSocio.value)).length > 0;
                    if (validaSocioRepetido) {
                        swal({
                            title: 'Este sócio já está adicionado!',
                            text: 'Digite outro CPF, por gentileza!',
                            icon: 'warning'
                        })
                        return;
                    }
                }
                if (this.formSocioErrors === 0) {
                    let socio = {};
                    socio.CsoNome = this.frmSocio.nomeSocio.value;
                    socio.CsoCpf = this.frmSocio.cpfSocio.value;
                    socio.CsoRg = this.frmSocio.rgSocio.value;
                    socio.CsoCargo = this.frmSocio.cargoSocio.value;
                    socio.CsoNascimento = this.frmSocio.dataNascimentoSocio.value;
                    socio.CsoEmail = this.frmSocio.emailSocio.value;
                    socio.CsoTelefone = this.frmSocio.telefoneSocio.value;
                    if (this.socios[this.socioIndex]) {
                        this.socios[this.socioIndex] = socio;
                        this.socioIndex++;
                    }

                    this.clearPartnerInputs();
                    if (this.socios[this.socioIndex]) {
                        this.frmSocio.nomeSocio.value = this.socios[this.socioIndex].label;
                        this.frmSocio.cargoSocio.value = this.socios[this.socioIndex].value.slice(3).trim();
                    }

                    this.frmSocio.attemptSubmit = false;
                    swal({
                        title: 'Sócio adicionado com sucesso!',
                        icon: 'success'
                    })
                }
            },
            clearPartnerInputs() {
                this.frmSocio.attemptSubmit = false;
                this.frmSocio.nomeSocio.value = '';
                this.frmSocio.rgSocio.value = '';
                this.frmSocio.cpfSocio.value = '';
                this.frmSocio.cargoSocio.value = '';
                this.frmSocio.emailSocio.value = '';
                this.frmSocio.telefoneSocio.value = '';
                this.frmSocio.dataNascimentoSocio.value = '';
            },         
            submitForms: function () {

                this.verificaEnderecoRural();
                var confirmaCadastro = this.formRegister.confirmaCadastroClienteRural;

                if (confirmaCadastro == false) {
                    this.loadingRegister = false;
                    return;
                }
                else {
                    if (this.formRegister.tipo == 0) {
                        this.formRegisterpf();
                    } else {
                        this.formRegisterpj();
                    }
                }  
            },
            verificaEnderecoRural: function () {
                var enderecoCompleto = this.frmEndereco.endereco.value + ", " + this.frmEndereco.numero.value + (this.frmEndereco.complemento.value != null ? ", " + this.frmEndereco.complemento.value : "");
                var bairro = this.frmEndereco.bairro.value;
                var cliRural = (this.frmEndereco.enderecoRural.value == true ? 1 : 0);

                this.formRegister.confirmaCadastroClienteRural = true;
                if ((enderecoCompleto.toUpperCase().includes("RURAL")) || (bairro.toUpperCase().includes("RURAL")) && (cliRural != true)) {

                    this.formRegister.confirmaCadastroClienteRural = false;

                    swal({
                        title: "Existe a palavra 'Rural' no Endereço/Bairro do Cliente e o mesmo não está marcado como Cliente Rural.",
                        text: "Deseja prosseguir com o Cadastro?",
                        icon: "warning",
                        buttons: true,
                    })
                        .then((confirmaCadastro) => {
                            if (confirmaCadastro) { 
                                this.formRegister.confirmaCadastroClienteRural = true;
                                this.loadingRegister = true;
                                if (this.formRegister.tipo == 0) {
                                    this.formRegisterpf();
                                } else {
                                    this.formRegisterpj();
                                }

                            } else {
                                this.formRegister.confirmaCadastroClienteRural = false;
                                this.loadingRegister = false;
                                return;
                            }
                        });

                    ///////////////////////////////////////

                }
            },
            getInfosCnpj(cnpj) {
                axios.get(this.$apiUrl + `Cliente.svc/infos-cnpj/${cnpj}/V`)
                    .then((response) => {
                        this.frmRegisterpj.loadingCnpj = false;
                        let empresa = response.data;
                        this.erroConsulta = empresa.message != "Pesquisa realizada com sucesso." ? true : false
                        if (empresa.code != '0') {
                            this.invalidCnpj = true;
                            swal({
                                title: 'Não foi possível validar seu CNPJ',
                                text: empresa.message,
                                icon: 'warning'
                            })
                                .then((confirm) => {
                                    if (confirm) {
                                        this.disabledForm = false;
                                        this.frmEndereco.disabledComplemento = false;
                                        this.frmRegisterpj.disabledFantasia = false;
                                    }
                                })
                        }
                        this.frmRegisterpj.razaoSocial.value = empresa.nome.replace(/[,"']/g, "").slice(0, 60);
                        if (empresa.fantasia.replace(/\*/g, '') == '')
                            this.frmRegisterpj.disabledFantasia = false;
                        else {
                            this.frmRegisterpj.nomeFantasia.value = empresa.fantasia.replace(/[,"']/g, "").slice(0, 60);
                            this.frmRegisterpj.disabledFantasia = true;
                        }
                        this.frmRegisterpj.fundacao.value = empresa.abertura;
                        this.frmRegisterpj.cnae.value = empresa.atividade_principal[0].code.trim();
                        this.ramoAtividade = empresa.atividade_principal[0].text.trim();
                        this.atividadesSecundarias = empresa.atividades_secundarias;
                        let cep = empresa.cep.replace(/[^\d]+/g, '');
                        this.frmEndereco.cep.value = empresa.cep;
                        let estados = this.getStates();
                        let estado = estados.filter(c => c.code == empresa.uf.toUpperCase())[0];
                        this.frmEndereco.estado.value = estado;
                        this.frmEndereco.cidade.value = empresa.municipio.normalize("NFD").toUpperCase();
                        let telefones = empresa.telefone.split('/');
                        this.frmEndereco.telefone.value = telefones[0].trim();
                        //this.frmEndereco.email.value = empresa.email;
                        //this.frmEndereco.emailConfirme.value = empresa.email;
                        this.frmEndereco.numero.value = empresa.numero;
                        if (empresa.logradouro.replace(/\*/g, '') == '')
                            this.frmEndereco.endereco = false;
                        else {
                            this.frmEndereco.endereco.value = empresa.logradouro.slice(0, 38);
                            this.frmEndereco.disabledEndereco = true;
                        }
                        //this.frmEndereco.endereco.value = empresa.logradouro.slice(0, 38);
                        this.frmEndereco.bairro.value = empresa.bairro.replace(",", "").replace("'", "").slice(0, 60);
                        if (empresa.complemento.replace(/\*/g, '') == '')
                            this.frmEndereco.disabledComplemento = false;
                        else {
                            this.frmEndereco.complemento.value = empresa.complemento.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '').replace(/[, ]+/g, " ").trim().replace(/["']/g, "").slice(0, 60);
                            this.frmEndereco.disabledComplemento = true;
                        }

                        if (empresa.qsa.length > 0 && empresa.qsa[0].nome != "") {
                            this.hasPartners = true;
                            empresa.qsa.forEach((element, index) => {
                                let socio = {};
                                socio.code = index;
                                socio.label = element.nome.slice(0, 60);
                                socio.value = element.qual === null ? '' : element.qual.slice(0, 60);
                                this.socios.push(socio);
                            })
                            this.frmSocio.nomeSocio.value = this.socios[this.socioIndex].label;
                            this.frmSocio.cargoSocio.value = this.socios[this.socioIndex].value.slice(3).trim();
                        }

                        this.frmEndereco.disabledEstado = true;
                        this.frmEndereco.disabledCep = true;
                        this.disabledForm = true;
                    })
                    .catch((error) => {
                        this.disabledForm = false;
                        this.frmRegisterpj.disabledFantasia = false;
                        this.frmEndereco.disabledComplemento = false;
                        this.frmRegisterpj.loadingCnpj = false;
                    })
            },
            getInfosFinancialCnpj(cnpj) {
                axios.get(`${this.$apiUrl}Cliente.svc/infos-financeiras-cnpj/${cnpj}/V`)
                    .then((response) => {
                        if (response.data) {
                            let infosFinanceiras = response.data;
                            this.frmRegisterpj.inscricaoEstadual.value = infosFinanceiras.inscricao_estadual;
                            if (infosFinanceiras.situacao_ie.toUpperCase() === 'ATIVO')
                                this.frmRegisterpj.situacaoIe = true;
                        }
                    })
            },
            formRegisterpj: function () {
                // Notifica que submit já foi realizado
                this.frmRegisterpj.attemptSubmit = true;
                this.frmEndereco.attemptSubmit = true;

                if (this.socios.length == 0 && this.hasPartners) {
                    this.formSocio.attemptSubmit = true;
                }

                let qtdeSocios = this.socios.length - this.socioIndex;
                if (qtdeSocios > 0 && this.hasPartners) {
                    swal({
                        title: `Ainda faltam ${qtdeSocios} sócios para serem cadastrados!`,
                        text: 'Por gentileza, cadastre-os.',
                        icon: 'warning'
                    })
                    this.loadingRegister = false;
                    return;
                }

                if (this.formErrors === 0) {
                    this.loadingRegister = true;
                    var dataString = this.frmRegisterpj.fundacao.value.split("/")
                    var data = new Date(dataString[2] + "-" + dataString[1] + "-" + dataString[0] + "T00:00:00");
                    var fundacao = data.getTime();

                    let obj = {};
                    obj.CliCiccgc = this.frmRegisterpj.cnpj.value;
                    obj.CliRazaosocial = this.frmRegisterpj.razaoSocial.value;
                    obj.CliNomefantasia = this.frmRegisterpj.nomeFantasia.value;
                    obj.CliFundacao = "/Date(" + fundacao + "-0300)/";
                    obj.CliIe = this.frmRegisterpj.inscricaoEstadual.value;
                    obj.CliQtdefiliais = this.frmRegisterpj.qtdeFilias.value === "" ? 0 : this.frmRegisterpj.qtdeFilias.value;
                    obj.EstUf = this.frmEndereco.estado.value.code;
                    obj.RatCodigo = this.frmRegisterpj.ramoAtividade.value.code;
                    obj.TraCodigo = 29;
                    obj.CliCnae = this.frmRegisterpj.cnae.value;
                    obj.CliLucroreal = this.frmRegisterpj.crt.value ? 0 : 2;

                    obj.CliBairro = this.frmEndereco.bairro.value.replace(",", "").replace("'", "");
                    obj.CliCep = this.frmEndereco.cep.value;
                    obj.CliTelefoneres = this.frmEndereco.telefone.value;
                    obj.CliCelularcontato = this.frmEndereco.telefoneCelular.value;
                    obj.CliContato = this.frmRegisterpj.comprador.value;
                    obj.CliFinanceiro = this.frmRegisterpj.financeiro.value;
                    obj.CliDiretor = this.frmRegisterpj.diretor.value;
                    obj.RamoAtividade = this.ramoAtividade;
                    obj.AtividadesSecundarias = this.atividadesSecundarias;

                    obj.CliEndereco = this.frmEndereco.endereco.value.replace(",", " ") + ", " + this.frmEndereco.numero.value + " " + this.frmEndereco.complemento.value;
                    obj.CliEndereco = obj.CliEndereco.slice(0, 60);
                    obj.CliEnderecoSn = this.frmEndereco.endereco.value;
                    obj.CliNumeroendereco = this.frmEndereco.numero.value;
                    obj.CliComplementoendereco = this.frmEndereco.complemento.value
                    obj.CliRural = this.frmEndereco.enderecoRural.value == true ? 1 : 0;

                    obj.CliCidade = this.frmEndereco.cidade.value.label;
                    obj.CliEmail = this.frmEndereco.email.value;
                    obj.CidCodigo = this.frmEndereco.cidade.value.code;
                    obj.CliComprovanteResidencia = this.frmEndereco.comprovanteEndereco.value;
                    obj.cepIsInvalid = this.frmEndereco.cepIsInvalid;


                    obj.TipoArquivo = this.frmEndereco.comprovanteEndereco.tipo;
                    obj.Clientessocios = this.socios;
                    obj.CliSituacao = (this.erroConsulta === false && this.frmRegisterpj.situacaoIe) ? 0 : 1;

                    obj.isPessoaFisica = false;


                    var xhr = new XMLHttpRequest();

                    xhr.onload = () => {
                        this.loadingRegister = false;
                        if (xhr.status == 200) {
                            swal({
                                title: "Cliente para venda direta cadastrado com sucesso",
                                icon: "success"
                            })
                                .then(() => {
                                    location.href = '/loja/minha-conta'
                                })
                        }
                        else if (xhr.status == 205) {
                            swal({
                                title: "Cliente já possui cadastro na Aldo:\r\n" + obj.CliCiccgc,
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 401) {
                            swal({
                                title: "É preciso estar logado para cadastrar Clientes para venda direta",
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 403) {
                            swal({
                                title: "Instabilidade no serviço de consulta Sintegra",
                                text: "Clique em salvar novamente. Se persistir, tente novamente mais tarde.",
                                icon: "warning"
                            })
                            gravaErro(xhr);
                        }
                        else if (xhr.status == 406) {
                            swal({
                                title: "Não é permitido cadastrar cliente final com mesmo e-mail ou telefone que a revenda",
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 412) {
                            swal({
                                title: "Não foi enviado o contrato de venda direta.",
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 413) {
                            swal({
                                title: "Comprovante de residência muito grande, tente usar arquivos menores que 2,5mb.",
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 417) {
                            swal({
                                title: "Instabilidade no serviço de consulta da Receita Federal",
                                text: "Clique em salvar novamente. Se persistir, tente novamente mais tarde.",
                                icon: "warning"
                            })
                        }
                        else {
                            swal({
                                title: 'Ops! Algo deu errado, tente novamente em alguns instantes.',
                                text: xhr.status + ' - ' + xhr.statusText,
                                icon: 'error'
                            })
                        }
                    }

                    xhr.open("POST", this.$apiUrl + "ClienteVendaDireta.svc/insert");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.withCredentials = true;
                    xhr.send(JSON.stringify(obj));
                }
            },
            formRegisterpf: function () {
                // Notifica que submit já foi realizado
                this.frmRegisterpf.attemptSubmit = true;
                this.frmEndereco.attemptSubmit = true;

                if (this.formErrors === 0) {
                    this.loadingRegister = true;
                    var dtNewNascimento = this.toDateISO(this.frmRegisterpf.dataNascimento.value) + ' 00:00:00';
                    //var dataString = this.frmRegisterpf.dataNascimento.value.split("/");
                    //var data = new Date(dataString[2] + "-" + dataString[1] + "-" + dataString[0] + "T00:00:00");
                    var dataNascimentoMiliSeconds = new Date(dtNewNascimento).getTime();

                    let obj = {};
                    obj.CliRazaosocial = this.frmRegisterpf.nome.value;
                    obj.CliCiccgc = this.frmRegisterpf.cpf.value;
                    obj.CliRg = this.frmRegisterpf.rg.value;
                    obj.CliOrgaoemissor = this.frmRegisterpf.orgaoEmissor.value;
                    obj.CliDatanascimento = "/Date(" + dataNascimentoMiliSeconds + ")/";
                    obj.CliEndereco = this.frmEndereco.endereco.value + ", " + this.frmEndereco.numero.value + (this.frmEndereco.complemento.value != null ? ", " + this.frmEndereco.complemento.value : "");
                    obj.CliEnderecoSn = this.frmEndereco.endereco.value;
                    obj.CliNumeroendereco = this.frmEndereco.numero.value;
                    obj.CliComplementoendereco = this.frmEndereco.complemento.value
                    obj.CliRural = this.frmEndereco.enderecoRural.value == true ? 1 : 0;
                    obj.CliCidade = this.frmEndereco.cidade.value.label;
                    obj.TraCodigo = 29;
                    obj.CliBairro = this.frmEndereco.bairro.value.replace(",", "").replace("'", "");
                    obj.EstUf = this.frmEndereco.estado.value.code;
                    obj.CliCep = this.frmEndereco.cep.value;
                    obj.CliTelefoneres = this.frmEndereco.telefone.value;
                    obj.CliCelularcontato = this.frmEndereco.telefoneCelular.value;
                    obj.CliEmail = this.frmEndereco.email.value;
                    obj.CidCodigo = this.frmEndereco.cidade.value.code;
                    obj.CliComprovanteResidencia = this.frmEndereco.comprovanteEndereco.value;
                    obj.TipoArquivo = this.frmEndereco.comprovanteEndereco.tipo;
                    obj.cepIsInvalid = this.frmEndereco.cepIsInvalid;
                    obj.isPessoaFisica = true;

                    var xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        this.loadingRegister = false;
                        if (xhr.status == 200) {
                            swal({
                                title: "Cliente para venda direta cadastrado com sucesso",
                                icon: "success"
                            })
                                .then(() => {
                                    location.href = '/loja/minha-conta'
                                })
                        }
                        else if (xhr.status == 205) {
                            swal({
                                title: "Cliente já possui cadastro na Aldo:\r\n" + obj.CliCiccgc,
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 401) {
                            swal({
                                title: "É preciso estar logado para cadastrar Clientes para venda direta",
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 403) {
                            swal({
                                title: "Instabilidade no serviço de consulta Sintegra",
                                text: "Clique em salvar novamente. Se persistir, tente novamente mais tarde.",
                                icon: "warning"
                            })
                            gravaErro(xhr);
                        }
                        else if (xhr.status == 406) {
                            swal({
                                title: "Não é permitido cadastrar cliente final com mesmo e-mail ou telefone que a revenda",
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 409) {
                            swal({
                                title: "A data de nascimento e/ou Nome do cliente divergem das informações da Receita Federal",
                                text: "Confirme as informações através de uma consulta ao CPF na Receita Federal",
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 412) {
                            swal({
                                title: "Não foi enviado o contrato de venda direta.",
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 413) {
                            swal({
                                title: "Comprovante de residência muito grande, tente usar arquivos menores que 2,5mb.",
                                icon: "warning"
                            })
                        }
                        else if (xhr.status == 417) {
                            swal({
                                title: "Instabilidade no serviço de consulta da Receita Federal",
                                text: "Clique em salvar novamente. Se persistir, tente novamente mais tarde.",
                                icon: "warning"
                            })
                        }
                        else {
                            swal({
                                title: 'Ops! Algo deu errado, tente novamente em alguns instantes.',
                                text: xhr.status + ' - ' + xhr.statusText,
                                icon: 'error'
                            })
                        }
                    }

                    xhr.open("POST", this.$apiUrl + "ClienteVendaDireta.svc/insert");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.withCredentials = true;
                    xhr.send(JSON.stringify(obj));
                }
            },
            gravaErro: function (error) {
                    var xhrLog = new XMLHttpRequest();
                    xhrLog.open("POST", "/ClienteVendaDireta.svc/gravaErro");
                    xhrLog.setRequestHeader("Content-Type", "application/json");
                    xhrLog.send(JSON.stringify({ erro: error }));
            },
            buildError: function (msg) {
                // Escreve o erro no formato padrão e retorna
                return { status: false, message: msg };
            },
            validateEmail: function (email) {
                const re = /[-.\w]+@([\w-]+\.)+[\w-]{2,20}/;

                return re.test(email);
            },
            clearString: function (str) {
                return str.replace(/[^\d]/g, "");
            },
            toDateISO: function (str) {
                return str.split('/').reverse().join('-');
            },
            formInput: function (required, value) {
                // Define um padrão para estrutura de cada input do formulário
                this.required = required !== undefined ? required : true;
                this.value = value !== undefined ? value : "";

                this.validation = {
                    // Status é o inverso do requerido, pois se o input for obrigatório, ele inicia com o status inválido
                    // Para que o usuário seja barrado em caso de um submit sem dados
                    status: !this.required,
                    message: this.required ? "Por favor, preencha o campo acima" : ""
                };
            },
            requiredValidation(val) {
                // Valida campos obrigatórios e retorna mensagem padrão
                const validation = {
                    status: !!val,
                    message: !val ? this.requiredFieldMessage : ""
                };

                return validation;
            },
            getStates: function () {
                // TODO: Fazer ajax para busca de estados
                const states = [
                    {
                        code: "AC",
                        label: "Acre"
                    },
                    {
                        code: "AL",
                        label: "Alagoas"
                    },
                    {
                        code: "AP",
                        label: "Amapá"
                    },
                    {
                        code: "AM",
                        label: "Amazonas"
                    },
                    {
                        code: "BA",
                        label: "Bahia"
                    },
                    {
                        code: "CE",
                        label: "Ceará"
                    },
                    {
                        code: "DF",
                        label: "Distrito Federal"
                    },
                    {
                        code: "ES",
                        label: "Espírito Santo"
                    },
                    {
                        code: "GO",
                        label: "Goiás"
                    },
                    {
                        code: "MA",
                        label: "Maranhão"
                    },
                    {
                        code: "MT",
                        label: "Mato Grosso"
                    },
                    {
                        code: "MS",
                        label: "Mato Grosso do Sul"
                    },
                    {
                        code: "MG",
                        label: "Minas Gerais"
                    },
                    {
                        code: "PA",
                        label: "Pará"
                    },
                    {
                        code: "PB",
                        label: "Paraíba"
                    },
                    {
                        code: "PR",
                        label: "Paraná"
                    },
                    {
                        code: "PE",
                        label: "Pernambuco"
                    },
                    {
                        code: "PI",
                        label: "Piauí"
                    },
                    {
                        code: "RJ",
                        label: "Rio de Janeiro"
                    },
                    {
                        code: "RN",
                        label: "Rio Grande do Norte"
                    },
                    {
                        code: "RS",
                        label: "Rio Grande do Sul"
                    },
                    {
                        code: "RO",
                        label: "Rondônia"
                    },
                    {
                        code: "RR",
                        label: "Roraima"
                    },
                    {
                        code: "SC",
                        label: "Santa Catarina"
                    },
                    {
                        code: "SP",
                        label: "São Paulo"
                    },
                    {
                        code: "SE",
                        label: "Sergipe"
                    },
                    {
                        code: "TO",
                        label: "Tocantins"
                    },
                ];

                return states;
            },
            //verificaEnderecoRural: function () {

            //},
            yesOrNoOptions: function () {
                const options = [
                    { code: 1, label: "Sim", value: true },
                    { code: 2, label: "Não", value: false }
                ];

                return options;
            },
            genereOptions: function () {
                const options = [
                    { code: 1, label: "Masculino", value: false },
                    { code: 2, label: "Feminino", value: true }
                ];

                return options;
            },
            getEstadoCivil: function () {
                const estadoCivil = [
                    { code: 0, label: "Casado(A)" },
                    { code: 1, label: "Solteiro(A)" },
                    { code: 2, label: "Viúvo(A)" },
                    { code: 3, label: "Separado(A)" },
                    { code: 4, label: "Outros" }
                ];

                return estadoCivil;
            },
            loadCidades: function () {
                const self = this;
                let cidade = {};
                let cidadeValue = null;
                try {
                    cidadeValue = this.frmEndereco.cidade.value.toUpperCase().replace(/[\u0300-\u036f]/g, '');
                }
                catch (e) {
                    cidadeValue = null;
                }

                self.frmEndereco.cidades = []

                if (self.frmEndereco.estado.value) {
                    $.ajax({
                        url: this.$apiUrl + "Cidades.svc/getcidades/" + self.frmEndereco.estado.value.code + "/N",
                        dataType: 'json',
                        contentType: "application/json",
                        type: 'GET',
                        success: (data) => {
                            self.frmEndereco.cidadeDisabled = false
                            data.forEach((element, index) => {
                                cidade = {};
                                cidade.code = element.CidCodigo,
                                    cidade.label = element.CidCidade;
                                self.frmEndereco.cidades.push(cidade);
                            })

                            if (cidadeValue) {
                                this.frmEndereco.cidade.value = this.frmEndereco.cidades.filter(c => c.label == cidadeValue)[0]
                                if (this.frmEndereco.cidade.value)
                                    this.frmEndereco.cidadeDisabled = true;
                            }
                            else
                                this.frmEndereco.cidade = new this.$formInput(true);
                        }
                    })
                }
                else {
                    self.frmEndereco.cidadeDisabled = true
                    self.frmEndereco.cidade.value = null;
                }
            },
            async getCepInfos(cep) {
                this.frmEndereco.disabledComplemento = false;
                cep = cep.replace(/-/g, "");
                 axios.get(`${this.$apiUrl}Transportadora.svc/busca-cep/${cep}`, { withCredentials: true })
                    .then((response) => {
                        try {
                            const localidade = response.data
                            if (localidade.rua) {
                                this.frmEndereco.endereco.value = this.removeAcento(localidade.rua).toUpperCase();
                                this.frmEndereco.bairro.value = this.removeAcento(localidade.bairro).toUpperCase();
                                this.frmEndereco.cidade.value = this.removeAcento(localidade.cidade).toUpperCase();
                                this.frmEndereco.estado.value = this.removeAcento(localidade.estado).toUpperCase();
                                this.frmEndereco.disabledEndereco = false;
                                this.frmEndereco.disabledBairro = false;
                                this.frmEndereco.cepIsInvalid = false;
                                this.frmEndereco.cidadeDisabled = true;
                                this.frmEndereco.disabledEstado = true;
                            }
                            else {
                                this.frmEndereco.disabledEndereco = false;
                                this.frmEndereco.disabledBairro = false;
                                this.frmEndereco.cepIsInvalid = true;
                                this.frmEndereco.estado.value = '';
                                this.frmEndereco.estado.value = '';
                                this.frmEndereco.bairro.value = '';
                                this.frmEndereco.endereco.value = '';
                                this.frmEndereco.cidade.value = '';
                                localidade.value = '';

                            }

                            if (localidade.estado) {
                                let estados = this.getStates();
                                let estado = estados.filter(c => c.code == localidade.estado)[0];

                                if (this.frmEndereco.cidade.value.label != null && this.removeAcento(localidade.cidade).toUpperCase() != this.frmEndereco.cidade.value.label) {
                                    swal({
                                        title: "Aviso",
                                        text: "A cidade selecionada não é a mesma do CEP",
                                        icon: 'warning'
                                    })
                                    this.frmEndereco.disabledEstado = false;
                                    this.frmEndereco.cidadeDisabled = false;
                                }
                                else {
                                    this.frmEndereco.disabledEstado = true;
                                    this.frmEndereco.cidadeDisabled = true;
                                }
                                this.frmEndereco.estado.value = estado;
                                this.frmEndereco.cidade.value = this.removeAcento(localidade.cidade).toUpperCase();
                            }
                            else {
                                this.frmEndereco.cidadeDisabled = false;
                                this.frmEndereco.disabledEstado = false;
                            }
                        }
                        catch (e) {
                            this.frmEndereco.disabledEstado = false;
                            this.frmEndereco.cidadeDisabled = false;
                            this.frmEndereco.disabledEndereco = false;
                            this.frmEndereco.disabledCep = false;
                            this.frmEndereco.cepIsInvalid = true;
                            this.frmEndereco.estado.value = '';
                            this.frmEndereco.bairro.value = '';
                            this.frmEndereco.endereco.value = '';
                            this.frmEndereco.cidade.value = '';
                            return;
                        }
                    })
                    .catch((error) => {
                        this.frmEndereco.disabledEstado = false;
                        this.frmEndereco.cidadeDisabled = false;
                        this.frmEndereco.disabledEndereco = false;
                        this.frmEndereco.disabledCep = false;
                        console.log(error)
                        return;
                    })

            },
            // getIP(){
            //     var xhr = new XMLHttpRequest();
            //         debugger;
            //         xhr.onload = () => {
            //             if (xhr.status == 200) {
            //                 return text;
            //             }
            //         }

            //         xhr.open("POST", this.$apiUrl + "ClienteVendaDireta.svc/GetPublicIP");
            //         xhr.setRequestHeader("Content-Type", "application/json");
            //         xhr.withCredentials = true;
            //         xhr.send(JSON.stringify(obj));
            // },
            removeAcento(text) {
                text = text.toLowerCase();
                text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
                text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
                text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
                text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
                text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
                text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
                return text;
            }
        }
    };
</script>

